import { Box, Chip, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import { formatTime } from "lib/format-time"
import { AmendsChangeType } from "authoring/lib/enum/amends-change-type.mjs"

export function LifecycleFieldChip({ item: key, tailored }) {
    if (key === "changeType") {
        const isAdded = tailored?.changeType === AmendsChangeType.ADDED
        const label = isAdded ? "Task Created" : "Task Deleted"
        const color = isAdded ? "success" : "error"
        return renderValueChip({ label, color })
    }

    const FIELD_RENDERERS = {
        classification() {
            const classification = tailored?.classification
            if (!classification) return null
            return renderValueChip({
                label: (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography variant="caption">Criticality</Typography>
                        <Iconify
                            sx={{ color: COLOR_FROM_CLASSIFICATION[classification] }}
                            icon={ICON_FROM_CLASSIFICATION[classification]}
                        />
                        <strong>{classification}</strong>
                    </Stack>
                ),
            })
        },
        minutes() {
            return renderValueChip({
                label: (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography variant="caption">Duration</Typography>
                        <strong>{formatTime(tailored?.minutes)}</strong>
                    </Stack>
                ),
            })
        },
        frequency() {
            const freq = tailored?.frequency?.label
            if (!freq) return null
            return renderValueChip({
                label: (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography variant="caption">Frequency</Typography>
                        <strong>every {freq}</strong>
                    </Stack>
                ),
            })
        },
        skill() {
            const skillLabel = tailored?.skill?.Skilling ?? tailored?.skill?.SkillingCode ?? tailored?.skill
            if (!skillLabel) return null
            return renderValueChip({
                label: (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography variant="caption">Skill</Typography>
                        <strong>{skillLabel}</strong>
                    </Stack>
                ),
            })
        },
        title() {
            return renderValueChip({
                label: (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <strong>{tailored?.title}</strong>
                    </Stack>
                ),
            })
        },
    }

    const renderer = FIELD_RENDERERS[key]
    return renderer ? renderer() : null
}

function renderValueChip({ label, color = "info" }) {
    return (
        <Box sx={{ py: 0.1 }}>
            <Chip
                size="small"
                sx={{
                    textTransform: "capitalize",
                    bgcolor: `${color}.lighter`,
                    color: "tailoredValueColors.text.main",
                }}
                color={color}
                label={label}
                data-cy="tailored-value-chip"
            />
        </Box>
    )
}
